export const IconNext = () => {
    return <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><polyline fill="none" stroke-width="4" points="7 2 17 12 7 22"></polyline></svg>
}